import { Box } from '@mui/material'
import React from 'react'
import { Button } from 'reactstrap'

export const AddNewLine = ({ table }) => {
  const handleAddRow = setFunction => {
    setFunction(prev => [...prev, { name: '', value: '' }])
  }
  return (
    <Box display="flex" justifyContent="space-between" marginTop="10px">
      <Button
        style={{
          backgroundColor: 'white',
          color: 'black',
          padding: '8px 16px',
          marginLeft: '3px',
        }}
        onClick={() => handleAddRow(table.setData)}
      >
        Añadir nueva línea
      </Button>
    </Box>
  )
}
